const ENTER_TRANSITION_DURATION_MS = 200;
const content = "_275cyf5pz0";
const transitionCls = "_275t1gq7pph";

export { ENTER_TRANSITION_DURATION_MS, content, transitionCls };
import "./page.styles.linaria.module.css";
//# sourceMappingURL=page.styles.js.map
